define('viewModels/privileged/qm/SearchResultsView',[
    'lib/knockout',
    'lib/lodash4',
    'moment',
    'jquery',
    'viewModels/ViewModel',
    'viewModels/privileged/qm/facetedSearch/SearchFacetsView',
    'viewModels/privileged/qm/facetedSearch/InteractionsSearchFacets',
    'viewModels/privileged/qm/InteractionsListView',
    'services/qm/interactionsListFilterService',
    'services/loggingService'

], function (ko,
             _,
             moment,
             $,
             ViewModel,
             SearchFacetsView,
             InteractionsSearchFacets,
             InteractionsListView,
             interactionsListFilterService,
             loggingService
    ) {
    'use strict';

    var SearchResultsView = ViewModel.extend(function () {
        var self = this;

        self.conversationSummary = ko.observable();
        self.conversationQuery = ko.observable();
        self.loading = ko.observable(true);
        var searchFiltersList = ko.observableArray();

        var opts = { preGatherLists: true, tableNamespace: 'INTERACTION_ARCHIVED_SEARCH_RESULTS_LIST'};
        self.interactionsListView = self.subView(InteractionsListView, searchFiltersList, true, opts);
        self.interactionFacets = self.subView(SearchFacetsView, InteractionsSearchFacets, searchFiltersList);

        // Get the last used search filter
        var filterKey = interactionsListFilterService.SEARCH_RESULTS_KEY;
        interactionsListFilterService.getFilters(filterKey)
            .then(function (lastSearchFilters) {
                var savedFilters = lastSearchFilters;
                // Clean filters that may have no values
                _.each(savedFilters,  function(filter){
                    if(_.isEmpty(filter.values)){
                        _.pull(savedFilters, filter);
                    }
                });

                if(savedFilters && savedFilters.length !== 0){
                    if (_.isEmpty(_.find(savedFilters, {target: "interval"}))){
                        savedFilters.push(self.interactionFacets.createDefaultFilter());
                    }
                } else {
                    savedFilters = [self.interactionFacets.createDefaultFilter()];
                }
                self.interactionFacets.createSavedFilterTemplates(savedFilters);
                searchFiltersList(ko.toJS(savedFilters));
            })
            .catch(function (error) {
                searchFiltersList([]);
                loggingService.error("Failed to retrieve the user's last search filter setting", error);
            })
            .finally(function () {
                // Update the search results
                self.interactionsListView.isSettingUp(false);
                self.loading(false);
            });

        self.subscribe(searchFiltersList, function (newValue) {
            var defaultValue = _.filter(newValue, function(item) {
                return !item.shouldNotSave;
            });
            interactionsListFilterService.setFilters(filterKey, defaultValue);

        });
    });
    return SearchResultsView;
});

